import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"
import utils from "@/utils"

let navbarMixin = {
    methods: {
        async openUserMenuModal() {
            this.$store.dispatch("sendMixpanelEvent", {
                msg: "User Menu Clicked"
            })
            if (
                this.$store.getters.isLoggedIn &&
                !this.$store.state.user.isVerified
            ) {
                const promise = utils.createPromise()
                eventBus.emit(EventBusEvents.OPEN_VERIFY_FLOW, {
                    resolve: promise.resolve
                })
                const verified = await promise.promise
                if (!verified) {
                    return
                }
            }
            this.$refs.userMenuModal.open()
        }
    }
}

export default navbarMixin